import React from 'react';
import { Helmet } from 'react-helmet-async';

interface StructuredDataProps {
  type?: 'LocalBusiness' | 'WebPage' | 'ContactPage';
}

const StructuredData: React.FC<StructuredDataProps> = ({ type = 'LocalBusiness' }) => {
  const getStructuredData = () => {
    const baseData = {
      "@context": "https://schema.org",
      "@type": type === 'LocalBusiness' ? "TaxiService" : "Organization",
      "name": "CABnHAUL",
      "description": "Premium luxury private transportation service offering executive car service, VIP rides, and personalized luxury transportation with professional drivers.",
      "url": "https://cabnhaul.com",
      "telephone": "+1-215-384-3448",
      "email": "CabnHaul@gmail.com",
      "priceRange": "$$$",
      "image": "https://cabnhaul.com/photo.png",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Philadelphia",
        "addressRegion": "PA",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "39.9526",
        "longitude": "-75.1652"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
          ],
          "opens": "00:00",
          "closes": "23:59"
        }
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+1-215-384-3448",
        "contactType": "Customer Service",
        "email": "CabnHaul@gmail.com",
        "availableLanguage": ["English"]
      },
      "sameAs": [
        "https://cabnhaul.com"
      ]
    };

    if (type === 'ContactPage') {
      return {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        "name": "Contact CABnHAUL",
        "description": "Get in touch with CABnHAUL for reliable transportation services",
        "url": "https://cabnhaul.com/contact",
        "mainEntity": {
          "@type": "LocalBusiness",
          "name": "CABnHAUL",
          "telephone": "+1-215-384-3448",
          "email": "CabnHaul@gmail.com"
        }
      };
    }

    return baseData;
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(getStructuredData())}
      </script>
    </Helmet>
  );
};

export default StructuredData;

